<template>
  <div>
    <el-table  border="true" stripe :data="floorInfoItemList"  style="width: 100%"
               class="line-table success-row" highlight-current-row="true" scrollbar-always-on="true"
               :cell-style="{ textAlign: 'center'}" :header-cell-style="{textAlign: 'center'}">
      <el-table-column label="序号" prop="index" width="80">
        <template v-slot="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="批号" prop="batch_no" width="120"/>
      <el-table-column label="窗番" prop="unit_no" width="120"/>
      <el-table-column label="单元类型" prop="unit_type" width="200"/>
      <el-table-column v-for="item in stageDataList" :key="item.id" width="160">
        <template v-slot:header>
          <span> {{ item.stage_name }}</span>
        </template>
        <template v-slot="scope">
        <div v-for="scanRecordDataList in scope.row.scanRecordDataList" :key="scanRecordDataList.id">
          <div v-if="item.id == scanRecordDataList.stage_id">
            {{ scanRecordDataList.scan_time}}
          </div>
        </div>
       </template>
      </el-table-column>
    </el-table>
    <div class="pageStyle">
      <el-pagination style="margin-right: 13px" background layout="sizes, total, prev, pager, next"
                     :total="total" :current-page="formData.pageNo" @current-change="currentCheckChange"
                     @size-change="handleSizeChange"
                     :page-size="formData.pageSize"
                     :small="false"
                     :disabled="false"
                     :page-sizes="[15, 30, 50, 100, 200]"
                     ></el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  name: "AmFloorInfoItem",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading:false,
      stageDataList:[],
      cnt:0,
      formData:{
        pageNo:1,
        pageSize:15,
      },
      total:0,
      floorInfoItemList:[],
    }
  },
  computed: {
  },
  methods:{
    currentCheckChange(pageNo){
      this.formData.pageNo = pageNo
      this.getFloorInfoItem()
    },
    handleSizeChange(pageSize){
      this.formData.pageSize = pageSize
      this.getFloorInfoItem()
    },
    //获取组立楼层详情数据
    getFloorInfoItem() {
      this.formData.wujian_id = this.parentData.wujian_id
      this.formData.floor = this.parentData.floor
      this.$axios.post('am/floorInfo/getFloorInfoItem', this.formData).then(response => {
        let res = response.data
        this.floorInfoItemList = res.data.infoList
        this.total = res.data.total

      })
    },
    //获取所有工站
    async getStageList() {
      let {data: res} = await this.$axios.get('/am/windowError/getStageAll');
      this.stageDataList = res.data;
    },
  },created() {
    this.getFloorInfoItem()
    this.getStageList()
  }
}
</script>

<style scoped>
.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}
</style>